//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';

export class TestCalendarEventInputItem extends ItemBase {
    StudentIndices: number[] = [];
    EventLocationIndex: number | null = null;
    EventCategoryIndex: number | null = null;
    TeacherIndex: number = 0;
    SubstituteTeacherIndex: number = 0;
    MaxNumberOfStudents: number | null = null;
    IsPublic: boolean = false;
    AllDay: boolean = false;
    StartDate: string | null = null;
    Duration: number | null = null;
    IsRecurring: boolean = false;
    IsMakeupRequired: boolean = false;
    Description: string | null = null;
    PrivateDescription: string | null = null;

    constructor(initializer?: Partial<TestCalendarEventInputItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "TestCalendarEventInputItem";
}
